import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useNotificationSettingsCardStyles = makeStyles((theme) =>
  createStyles({
    selectRow: {
      display: 'flex',
      flexDirection: 'column',

      '& > div': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 32,

        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',

          '& > p': {
            marginBottom: 8
          }
        }
      }
    },

    title: {
      marginBottom: 32
    },

    root: {
      padding: 0,
      marginBottom: 48
    },

    button: {
      marginLeft: 'auto'
    }
  })
)
